var _path, _rect, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgOrangeBookmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 36,
    viewBox: "0 0 24 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 36L12 26.7487L24 36V0H0V36ZM3.00014 29.1087V3.85742H20.143V29.1087L11.5716 22.7146L3.00014 29.1087Z",
    fill: "#FCA311"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2.57141,
    y: 3.85693,
    width: 18,
    height: 21.8571,
    fill: "#FCA311"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8571 22.5H1.92855V30.8571L12.2143 24.4286L21.8571 30.8571V22.5Z",
    fill: "#FCA311"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrangeBookmark);
export default __webpack_public_path__ + "static/media/orange-bookmark.915d434b30308ebb1ca7b5096bf7f5a2.svg";
export { ForwardRef as ReactComponent };